/* eslint-disable @typescript-eslint/no-unused-vars */
import { first } from 'rxjs/operators';
import { EVENTS } from '../../../../../app/constants/events';
import { loadSelectPickerItems } from '../../../../../app/common/store/select-picker.actions';
import { queryParamsMap } from '../../../../../app/common/components/forms/select-picker/select-picker-types.enum';
import { connectionIconUrlByType } from '../../../../../app/common/helper/connection-icon-url-by-type.helper';
import { selectConnectionTypes } from '../../../../../app/connections/store/connections.selectors';
import { COMPONENT_TYPE } from '../../../../../app/constants/component_type';

xplenty.controller('ConnectionStep', [
  '$scope',
  '$rootScope',
  '$translate',
  'selectPickerModal',
  'ngrxStoreService',
  function ($scope, $rootScope, $translate, selectPickerModal, ngrxStoreService) {
    $scope.hasComponentChanged = 0;
    $scope.connection = $scope.component.connection || null;
    $scope.connectionQuery = {
      type: $scope.component.connectionTypes,
    };
    $scope.connectionTypes = $scope.component.connectionTypes.split(',');
    selectPickerModal.setConnectionTypes($scope.connectionTypes.join());
    $scope.selectConnection = (connection) => {
      $scope.connection = connection;
      $scope.component.connection = connection;
    };

    $scope.onCreateNewConnection = ({ connection, type }) => {
      if (!connection) {
        ngrxStoreService
          .select(selectConnectionTypes)
          .pipe(first())
          .subscribe((types) => {
            selectPickerModal.createNew(
              types.find((item) => item.type === $scope.component.connectionTypes),
              type,
              'connection-picker-component-editor',
            );
          });
      } else {
        selectPickerModal.createNew(connection, type, 'connection-picker-component-editor');
      }

      const subscriber = $rootScope.$on(EVENTS.CONNECTION_CREATED, (event, connectionItem) => {
        ngrxStoreService.dispatch(
          loadSelectPickerItems({
            id: 'connection-picker-component-editor',
            itemType: type,
            params: { ...queryParamsMap[type], ...$scope.connectionQuery },
          }),
        );
        $scope.selectConnection(connectionItem);
        subscriber();
      });
    };

    const closedText = $translate.instant(`component-editor.step-connection.${$scope.component.type}.closed`);
    const activeText = $translate.instant(`component-editor.step-connection.${$scope.component.type}.active`);

    $scope.connectionStep = $scope.$parent.createStep(
      closedText,
      activeText,
      `<xp-select-picker-editable
                          id="connection-picker-component-editor"
            type="connection"
            [value]="connection"
            placeholder="Select connection"
            empty-placeholder="Connections list is empty"
            on-value-change="selectConnection($event)"
            on-create-new="onCreateNewConnection($event)"
            [params]="connectionQuery"
            bind-connection-types="connectionTypes"
          ></xp-select-picker-editable>
        <dynamic-connection [component]="component" on-component-change="componentUpdate($event)" bind-has-component-changed="hasComponentChanged"
      ng-if="shouldShowDynamicConnection"></dynamic-connection>`,
    );

    $scope.componentUpdate = function (component) {
      $scope.component.dynamic_connection = component.dynamic_connection;
    };

    $scope.shouldShowDynamicConnection =
      [
        COMPONENT_TYPE.DATABASE_SOURCE_COMPONENT,
        COMPONENT_TYPE.DATABASE_DESTINATION_COMPONENT,
        COMPONENT_TYPE.MONGO_DESTINATION_COMPONENT,
        COMPONENT_TYPE.MONGO_SOURCE_COMPONENT,
        COMPONENT_TYPE.CLOUD_STORAGE_SOURCE_COMPONENT,
        COMPONENT_TYPE.CLOUD_STORAGE_DESTINATION_COMPONENT,
        COMPONENT_TYPE.BIG_QUERY_DESTINATION_COMPONENT,
        COMPONENT_TYPE.BIG_QUERY_SOURCE_COMPONENT,
      ].includes($scope.component.componentType) && $rootScope.account.permissions.includes('dynamicConnection');

    $scope.$watch(
      'connection',
      function (newConnection, oldConnection) {
        if (oldConnection && newConnection && newConnection.id !== oldConnection.id) {
          $scope.hasComponentChanged += 1;
        }

        if (newConnection && $scope.connectionStep.validate()) {
          const img = `<img class="tag-icon" src="${connectionIconUrlByType(newConnection.type)}" alt="${
            newConnection.name
          }" />`;

          $scope.connectionStep.tags = [
            {
              icon: '',
              name: `${img}<b>${_.escape(newConnection.name)}</b>`,
            },
          ];
        }
      },
      true,
    );

    $scope.$watch(
      'component',
      function (newComponent, oldComponent) {
        if (newComponent && newComponent.name !== oldComponent.name) {
          $scope.hasComponentChanged += 1;
        }
        if (newComponent.dynamic_connection) {
          if (!$scope.connectionStep.tags.find((tag) => tag.name === $scope.component.dynamic_connection)) {
            $scope.connectionStep.tags = [
              ...$scope.connectionStep.tags,
              {
                name: $scope.component.dynamic_connection,
              },
            ];
          }
        } else {
          $scope.connectionStep.tags = $scope.connectionStep.tags.filter(
            (tag) => tag.name !== $scope.component.dynamic_connection,
          );
        }
      },
      true,
    );

    $scope.connectionStep.validate = function () {
      const { connection } = $scope.component;
      this.valid = connection && connection.id;
      if (!this.valid) {
        this.tags = [];
      }
      return this.valid;
    };
  },
]);
